export class SyntheseDeclarationControle {
    static jsonMap = {
        annee: 'annee',
        libelleCDC: 'libelleCDC',
        typeDeclaration: 'typeDeclaration',
        nbLot: 'nbLot',
        volumeDeclare: 'volumeDeclare',
        nbControle: 'nbControle',
        volumeControle: 'volumeControle'
    };

    annee: string;
    libelleCDC: string;
    typeDeclaration: string;
    nbLot = 0;
    volumeDeclare = 0;
    nbControle = 0;
    volumeControle = 0;
}
